export default __webpack_public_path__ + "static/media/logo-white.b448cc3b.svg";